module.exports = __webpack_public_path__ + "img/undraw_photo_4yb9.a01b5a97.svg";